import { render, staticRenderFns } from "./joinOasis.vue?vue&type=template&id=5c019470&scoped=true&"
import script from "./joinOasis.vue?vue&type=script&lang=js&"
export * from "./joinOasis.vue?vue&type=script&lang=js&"
import style0 from "./joinOasis.vue?vue&type=style&index=0&id=5c019470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c019470",
  null
  
)

export default component.exports